import {Component, Injector, OnInit} from '@angular/core';
import {AsistenciaService} from '../_services/asistencia.service';

@Component({
  selector: 'asistencia-curso-barra',
  standalone: false,
  template: `
      <div class="header-mainInfo">
          <h1 class="control-item">Asistencia</h1>
          <span class="header-mainInfo__separator">/</span>
          <h1 class="title-re" *ngIf="materiaCursoPeriodo">{{materiaCursoPeriodo.nombre}}</h1>
      </div>`,
  styleUrls: [
    './asistencia-curso.component.scss'],
})

export class AsistenciaCursoBarraComponent implements OnInit {

  materiaCursoPeriodo: any;

  showSidebar = true;

  constructor(private injector: Injector,
              private asistenciaService: AsistenciaService) {
  }

  ngOnInit() {
    this.materiaCursoPeriodo = this.injector.get('materiaCursoPeriodo');
  }
}
